import React from 'react';
import { useSelector } from 'react-redux';

import { Fire, Tools, Time } from '../../services'

import Switch from 'react-switch'
import Select from 'react-select';
import { Headerbar, StatusBox, FormInput, Loader, EditContainer, ImagesPicker, ListContainer, ConfirmButton } from '../Reusable'

import FadeIn from 'react-fade-in';

const { useHistory } = require('react-router-dom')

interface Props {
  element: any;
}
const TicketingPromos: React.FC<Props> = (props) => {

  const history = useHistory()
  const [error, setError] = React.useState('')
  const elementId = props.element.id
  const elementRef = Fire.collection('ads').doc(elementId)

  const onFetch = async () => {
    try {
      const list = await Fire.list(elementRef.collection('promos'))
      for (const item of list) {
        item.type_col = item.type === 'percentage' ? 'Pourcentage (%)' : 'Réduction (€)'
        item.value_col = item.type === 'percentage' ? (item.value || 0) + '%' : Tools.renderPrice(item.value)
        item.date_created_col = item.createdAt ? Fire.getDateFor(item.createdAt) : new Date()
        item.date_col = item.createdAt ? Time.moment(Fire.getDateFor(item.createdAt)).format('DD/MM/YYYY HH[h]mm') : '-'
      }
      return list
    } catch (err) {
      setError("Impossible de charger les codes promos")
      console.warn(err)
    }
    return []
  }

  const onActive = async (item: any, refresh: any) => {
    try {
      await elementRef.collection('promos').doc(item.id).update({ active: !item.active })
      refresh()
    } catch (err) {
      setError("Impossible de modifier le code promo")
      console.warn(err)
    }
  }

  const sorting = (search: string, items: any[]) => {
    return items.filter((item) => Tools.matchesSearch(search, item.name))
  }

  return (
    <ListContainer
      title="Codes promos"
      searchTitle="Rechercher un code promo..."
      createTitle="Créer un code promo"
      error={error}
      onFetch={onFetch}
      onCreate={() => history.push('/ticketing/' + elementId + '/promo/new')}
      onSelect={(item) => history.push('/ticketing/' + elementId + '/promo/' + item.id)}
      sorting={sorting}
      renderColumns={({ refresh }) => ([
        { name: 'Nom', string: 'name', sortable: true, accessor: 'name' },
        { name: 'Code', string: 'code', sortable: true, accessor: 'code' },
        { name: 'Type de réduction', string: 'type_col', sortable: true, accessor: 'type_col' },
        { name: 'Réduction', sortable: true, accessor: 'value_col' },
        { name: 'Vendus', sortable: true, accessor: 'count' },
        { name: 'Statut', accessor: 'status', cell: (item) => (
          <StatusBox
            status={item.active ? 'Affiché' : 'Caché'}
            type={item.active ? 'success': 'off'}
            />
        ) },
        { name: 'Créé le', date: 'date_created_col', sortable: true, accessor: 'date_col' },
      ])}
      />
  );
}

export default TicketingPromos
